import React, { SyntheticEvent } from 'react';
import styles from './ChatroomUpdate.scss';
import { connect } from 'react-redux';
import {
  headerFontFamily,
  headerTextColorOrDefault,
  messagesFontFamily,
  primaryColorOrDefault,
} from '../../reducers';
import { InjectedTranslateProps, translate } from 'react-i18next';
import AvatarPlaceHolder from '../../icons/dist/components/avatarPlaceHolder';
import Button from '../Button/Button';
import serverApi from '../../services/serverApi';
import { mediaManager } from '@wix/inbox-common';
import { Loader } from '../Loader/Loader';

interface ChatroomUpdateProps extends InjectedTranslateProps {
  primaryColor: string;
  headerTextColor: string;
  image?: string;
  name?: string;
  numberOfMembers: string;
  submitButtonText: string;
  submitButtonCallback: any;
  messageFont: string;
  headerFont: string;
}

interface ChatroomUpdateState {
  chatroomImage: string;
  chatroomName: string;
  presentImageLoader: boolean;
}

class _ChatroomUpdate extends React.Component<
  ChatroomUpdateProps,
  ChatroomUpdateState
> {
  constructor(props: ChatroomUpdateProps) {
    super(props);

    this.state = {
      chatroomImage: this.props.image ? this.props.image : '',
      chatroomName: this.props.name ? this.props.name : '',
      presentImageLoader: false,
    };
  }

  handleFileSelect = async (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const file = target.files && target.files[0];

    this.setState({ presentImageLoader: true });

    const { token, url, folderId } = await serverApi.getUploadToken();
    const returnFromMedia = await mediaManager.uploadFileToMedia({
      file,
      token,
      uploadUrlApi: url,
      folderId,
    });
    this.setState({
      chatroomImage: returnFromMedia.url,
      presentImageLoader: false,
    });
  };

  submitClicked = async () =>
    this.props.submitButtonCallback({
      name: this.state.chatroomName,
      image: this.state.chatroomImage,
    });

  render() {
    const {
      t,
      primaryColor,
      headerTextColor,
      numberOfMembers,
      submitButtonText,
      image,
      name,
      headerFont,
    } = this.props;

    const { chatroomName, chatroomImage, presentImageLoader } = this.state;

    const submitButtonDisabled =
      chatroomName.length <= 0 ||
      (chatroomName === name && chatroomImage === image);
    const colorWhite = '#FFFFFF';
    const colorWhiteWithOpacity = `rgba(255, 255, 255, 0.2)`;

    return (
      <div
        className={styles.addGroupChatroomDetail}
        data-hook="update-group-chatroom-wrapper"
      >
        <div
          className={styles.chatroonHeader}
          style={{ backgroundColor: primaryColor }}
        >
          <div className={styles.chatroomImage}>
            {presentImageLoader ? (
              <div
                id="container"
                data-hook="group-chatroom-image-loader"
                className={styles.chatroomImageLoader}
                style={{ backgroundColor: colorWhiteWithOpacity }}
              >
                <div className={styles.chatroomLoader}>
                  <Loader dimensions={24} borderWidth={3} color={colorWhite} />
                </div>
              </div>
            ) : chatroomImage ? (
              <img
                data-hook="group-chatroom-image"
                className={styles.chatroomImagePic}
                alt="group chat image"
                src={chatroomImage}
              />
            ) : (
              <AvatarPlaceHolder
                size="60px"
                style={{ color: headerTextColor }}
                className={styles.chatroomImageIcon}
                data-hook={'group-chatroom-image-placeholder'}
              />
            )}
            <input
              type={'file'}
              accept={'image/*,.png,.jpg,.bpm'}
              className={styles.chatroomImageButton}
              data-hook="group-chatroom-image-button"
              onChange={this.handleFileSelect}
            />
          </div>
          <div
            className={styles.chatroomNameDiv}
            style={{ fontFamily: headerFont }}
          >
            <input
              className={styles.chatroomName}
              data-hook="group-chatroom-name"
              type="text"
              onChange={(event) =>
                this.setState({ chatroomName: event.target.value })
              }
              placeholder={t('social.group-chat.name-placeholder')}
              style={{ color: headerTextColor }}
              value={this.state.chatroomName}
            />
          </div>
          <div
            className={styles.chatroomSeperator}
            style={{ backgroundColor: headerTextColor }}
          ></div>
          <div
            className={styles.memberSelected}
            data-hook="group-chatroom-number-members"
            style={{ color: headerTextColor, fontFamily: headerFont }}
          >
            {t('social.group-chat.number-members', { number: numberOfMembers })}
          </div>
        </div>
        <div className={styles.newChat} style={{ fontFamily: headerFont }}>
          <Button
            dataHook="group-chatroom-submit-button"
            onClick={this.submitClicked}
            disabled={submitButtonDisabled}
          >
            {submitButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: primaryColorOrDefault(state),
    headerTextColor: headerTextColorOrDefault(state),
    messageFont: messagesFontFamily(state),
    headerFont: headerFontFamily(state),
  };
};

const mapDispatchToProps = (state) => ({});

export const ChatroomUpdate = connect(
  mapStateToProps,
  mapDispatchToProps,
)(translate()(_ChatroomUpdate));
